import React from "react";
import { GALLERY } from "../lib/constants";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 border-t border-[#332C27]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 reveal">
          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-bold mb-4">
              / 04 — Recent work
            </div>
            <h2
              data-testid="gallery-heading"
              className="font-display text-4xl md:text-5xl lg:text-6xl text-[#F9FAFB] font-semibold uppercase tracking-tight"
            >
              Proof is in
              <br />
              <span className="text-[#F5A623]">the portfolio.</span>
            </h2>
          </div>
          <p className="text-[#A19D98] max-w-sm text-base leading-relaxed">
            A few recent jobs from around Lehigh Acres, Fort Myers and Cape
            Coral. Lighting, doors, gutters and everything in between.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {GALLERY.map((item, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`reveal relative overflow-hidden rounded-xl border border-[#332C27] group ${
                i === 0 ? "col-span-2 row-span-2" : ""
              }`}
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-[900ms] group-hover:scale-105 ${
                  i === 0 ? "h-full min-h-[320px] md:min-h-[480px]" : "h-44 md:h-56"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#14110F]/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <span className="text-xs text-[#F5A623] uppercase tracking-[0.2em] font-bold">
                  View in portfolio →
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
